import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="h-screen flex flex-col items-center justify-center text-center">
            <h1 className="text-6xl font-bold text-gray-700">404</h1>
            <p className="text-lg mt-2 text-gray-500">
                Page not found
            </p>

            <button
                onClick={() => navigate("/dashboard")}
                className="mt-4 px-4 py-2 bg-[var(--base-color)] text-white rounded-lg"
            >
                Go to Dashboard
            </button>
        </div>
    );
};

export default NotFound;